export class HoSendMessages {
  static readonly SEND_HO_SUCCESS_INI = 'El Handover';
  static readonly SEND_HO_SUCCESS_END = 'se envió exitosamente.';
  static readonly SEND_HO_ERROR_INI =
    'Hubo un problema y el Handover no pudo ser enviado.';
  static readonly SEND_HO_ERROR_END = 'Por favor, intentelo nuevamente.';
  static readonly SUCCESS_NOTIFICATION = true;
  static readonly ERROR_NOTIFICATION = false;
}
